// extracted by mini-css-extract-plugin
module.exports = {"box":"zvpc6","child":"riHQN","header":"_15Yvn","paymentMethods":"_1vfSO"};